import PropTypes from "prop-types"

import AdminCallingNumberDeleteDialog from "./AdminCallingNumberDeleteDialog"
import AdminCallingNumberEditDialog from "./AdminCallingNumberEditDialog"

export default function AdminCallingNumberDialogHost({
  editRow,
  deleteRow,
  saving,
  dialogError,
  onClose,
  onSave,
  onConfirmDelete,
}) {
  return (
    <>
      <AdminCallingNumberEditDialog
        open={Boolean(editRow)}
        assignment={editRow}
        onClose={onClose}
        onSave={onSave}
        saving={saving}
        errorMessage={editRow ? dialogError : null}
      />
      <AdminCallingNumberDeleteDialog
        open={Boolean(deleteRow)}
        assignment={deleteRow}
        onClose={onClose}
        onConfirm={onConfirmDelete}
        saving={saving}
        errorMessage={deleteRow ? dialogError : null}
      />
    </>
  )
}

AdminCallingNumberDialogHost.propTypes = {
  editRow: PropTypes.object,
  deleteRow: PropTypes.object,
  saving: PropTypes.bool,
  dialogError: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onConfirmDelete: PropTypes.func.isRequired,
}
